import React from "react";
import PropTypes from "prop-types";
import PageArrow from "./PageArrow";
import { ReactComponent as ArrowIcon } from "images/icons/arrow.svg";
import { cn } from "components/helpers/utils";
import { usePagination } from "hooks/usePagination";

export default function PageSelector({
  currentPage,
  totalPages,
  setCurrentPage,
  className = "",
}) {
  const { startPage, endPage, visiblePages, canGoBack, canGoForward } =
    usePagination({
      currentPage,
      totalPages,
      pagesToShow: 5,
    });

  if (totalPages <= 1) return null;

  return (
    <div className={cn(`flex items-center pr-4 gap-3`, className)}>
      <PageArrow
        disabled={!canGoBack}
        icon={<ArrowIcon className="-rotate-90 h-2.5" />}
        onClick={() => setCurrentPage?.(currentPage - 1)}
      />

      {/* Afficher "1" et "..." si on n'est pas au début */}
      {startPage > 1 && (
        <>
          <button
            className={`font-semibold text-sm text-stone-300`}
            onClick={() => setCurrentPage?.(1)}
          >
            1
          </button>
          {startPage > 2 && <span className="text-stone-300">...</span>}
        </>
      )}

      {/* Pages visibles */}
      {visiblePages.map((page) => (
        <button
          key={page}
          className={`font-semibold text-sm ${
            currentPage === page ? "text-main-color" : "text-stone-300"
          }`}
          onClick={() => setCurrentPage?.(page)}
        >
          {page}
        </button>
      ))}

      {/* Afficher "..." et dernière page si on n'est pas à la fin */}
      {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && (
            <span className="text-stone-300">...</span>
          )}
          <button
            className={`font-semibold text-sm text-stone-300`}
            onClick={() => setCurrentPage?.(totalPages)}
          >
            {totalPages}
          </button>
        </>
      )}

      <PageArrow
        disabled={!canGoForward}
        icon={<ArrowIcon className="rotate-90 h-2.5" />}
        onClick={() => setCurrentPage?.(currentPage + 1)}
      />
    </div>
  );
}

PageSelector.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  setCurrentPage: PropTypes.func.isRequired,
  className: PropTypes.string,
};

PageSelector.defaultProps = {
  currentPage: 1,
  totalPages: 0,
};
